// Public surface of the collections feature (Instance B, collections sprint).
//
// The registry imports the default (the page) and `collectionsIcon` for its one
// entry. Other screens mount the chip, one line each:
//
//   import { PayStatusChip } from '../collections';
//   <PayStatusChip practiceId={practiceId} patientId={patientId} />
//
// The chip gates itself on `features.collections`, so it is safe to mount
// unconditionally.

import React from "react";

export { default } from "./CollectionsPage";
export { default as CollectionsPage } from "./CollectionsPage";
export { default as PayStatusChip } from "./PayStatusChip";
export { default as CollectionsSettingsCard } from "./CollectionsSettingsCard";
// Practice Details calls this after a rename: the consent wording quotes the name.
export { invalidateSettings as invalidateCollectionsSettings } from "./api";

export const feature = "collections";

export const collectionsIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <rect x="2" y="5" width="20" height="14" rx="2" />
    <path d="M2 10h20" />
    <path d="M6 15h4" />
  </svg>
);
